import { render, staticRenderFns } from "./CashiersTab.vue?vue&type=template&id=2e5ec8fe&scoped=true&"
import script from "./CashiersTab.vue?vue&type=script&lang=js&"
export * from "./CashiersTab.vue?vue&type=script&lang=js&"
import style0 from "./CashiersTab.vue?vue&type=style&index=0&id=2e5ec8fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5ec8fe",
  null
  
)

export default component.exports